import Chip from '../primitives/Chip'
import styles from './RoadTripSnackSelector.module.css'

const MAX_SELECTIONS = 3

const SNACKS = [
  'Sour Patch Kids',
  'Circus Peanuts',
  'Twizzlers',
  '90% Dark Chocolate',
  'Beef Jerky',
  'Flaming Hot Anything',
  'Trail Mix',
  'Pretzels',
  'Pickles in a Pouch',
  'Sunflower Seeds',
  'Baby Carrots',
  'Protein Bars',
  'Corn Nuts',
  "Peanut M&M's",
  'Leftover Lasagna',
  'Water Only',
  'Whole Fruit',
  'Hard Boiled Eggs',
]

interface RoadTripSnackSelectorProps {
  selectedSnacks: string[]
  onChange: (snacks: string[]) => void
}

export default function RoadTripSnackSelector({
  selectedSnacks,
  onChange,
}: RoadTripSnackSelectorProps) {
  const isFull = selectedSnacks.length >= MAX_SELECTIONS
  const options = [...new Set([...SNACKS, ...selectedSnacks])]

  function toggleSnack(snackName: string) {
    onChange(
      selectedSnacks.includes(snackName)
        ? selectedSnacks.filter((s) => s !== snackName)
        : [...selectedSnacks, snackName],
    )
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.chips}>
        {options.map((name) => {
          const isSelected = selectedSnacks.includes(name)
          return (
            <Chip
              key={name}
              label={name}
              selected={isSelected}
              disabled={isFull && !isSelected}
              onClick={() => toggleSnack(name)}
            />
          )
        })}
      </div>
      <p className={styles.count}>
        {selectedSnacks.length} of {MAX_SELECTIONS} chosen
      </p>
    </div>
  )
}
